import { render, staticRenderFns } from "./login-view.vue?vue&type=template&id=0b1c3405&scoped=true&"
import script from "./login-view.vue?vue&type=script&lang=js&"
export * from "./login-view.vue?vue&type=script&lang=js&"
import style0 from "./login-view.vue?vue&type=style&index=0&id=0b1c3405&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1c3405",
  null
  
)

export default component.exports